(function () {
  const getDialog = () => document.querySelector('dialog[data-mc-sg]');
  const openDialog = (dlg) => {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', 'open');
  };
  const closeDialog = (dlg) => {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
  };

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-mc-sg-open]');
    const closeBtn = e.target.closest('[data-mc-sg-close]');
    const dlg = getDialog();

    if (openBtn) openDialog(dlg);
    if (closeBtn) closeDialog(dlg);
  });

  document.addEventListener('mousedown', (e) => {
    const dlg = e.target.closest('dialog[data-mc-sg]');
    if (!dlg || !dlg.open) return;
    const panel = dlg.querySelector('.mc-sg__panel');
    if (panel && !panel.contains(e.target)) closeDialog(dlg);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const dlg = getDialog();
    if (dlg && dlg.open) closeDialog(dlg);
  });
})();
